import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  FormControlLabel,
  FormGroup
} from "@mui/material";
import PrimaryCheckbox from "../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";
import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../Buttons/SecondaryButton/SecondaryButton";
import StyledPopover from "../../../StyledPopover/StyledPopover";
import FilterButton from "../../../Buttons/FilterButton/FilterButton";
import CallinStatusPill from "../../../Pills/CallinStatusPill/CallinStatusPill";

export default function CallinStatusFilter({
  column: { filterValue, setFilter, Header },
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [values, setValues] = useState([]);
  const [isPrevious, setIsPrevious] = useState(false);
  const [isPreplan, setIsPreplan] = useState(false);
  const [isDrvrdna, setIsDrvrdna] = useState(false);
  const [isDispatch, setIsDispatch] = useState(false);
  const [isDly2Ship, setIsDly2Ship] = useState(false);
  const [isAtShipr, setIsAtShipr] = useState(false);
  const [isShipDlay, setIsShipDlay] = useState(false);
  const [isMoving, setIsMoving] = useState(false);
  const [isDotBreak, setIsDotBreak] = useState(false);
  const [isItDelay, setIsItDelay] = useState(false);
  const [isAtDelvry, setIsAtDelvry] = useState(false);
  const [isConsDlay, setIsConsDlay] = useState(false);
  const open = Boolean(anchorEl);
  const pid = open ? "callin-status-filter-popover" : undefined;
  const allStatus = ["PREVIOUS ", "PREPLAN", "DRVRDNA", "DISPATCH", "DLY2SHIP", "ATSHIPR", "SHIPDLAY", "MOVING", "DOTBREAK", "ITDELAY", "ATDELVRY", "CONSDLAY"];

  const statuses = [
    {
      id: "PREVIOUS",
      value: isPrevious
    },
    {
      id: "PREPLAN",
      value: isPreplan
    },
    {
      id: "DRVRDNA",
      value: isDrvrdna
    },
    {
      id: "DISPATCH",
      value: isDispatch
    },
    {
      id: "DLY2SHIP",
      value: isDly2Ship
    },
    {
      id: "ATSHIPR",
      value: isAtShipr
    },
    {
      id: "SHIPDLAY",
      value: isShipDlay
    },
    {
      id: "MOVING",
      value: isMoving
    },
    {
      id: "DOTBREAK",
      value: isDotBreak
    },
    {
      id: "ITDELAY",
      value: isItDelay
    },
    {
      id: "ATDELVRY",
      value: isAtDelvry
    },
    {
      id: "CONSDLAY",
      value: isConsDlay
    },
  ];

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelected = (event) => {
    const status = event.target.value;
    const value = event.target.checked;

    if (value) {
      let updatedValues = values;
      updatedValues.push(status);
      setValues(updatedValues);
    } else {
      setValues(values.filter(value => value != status));
    }

    switch (status) {
      case "PREVIOUS":
        setIsPrevious(value);
        break;
      case "PREPLAN":
        setIsPreplan(value);
        break;
      case "DRVRDNA":
        setIsDrvrdna(value);
        break;
      case "DISPATCH":
        setIsDispatch(value);
        break;
      case "DLY2SHIP":
        setIsDly2Ship(value);
        break;
      case "ATSHIPR":
        setIsAtShipr(value);
        break;
      case "SHIPDLAY":
        setIsShipDlay(value);
        break;
      case "MOVING":
        setIsMoving(value);
        break;
      case "DOTBREAK":
        setIsDotBreak(value);
        break;
      case "ITDELAY":
        setIsItDelay(value);
        break;
      case "ATDELVRY":
        setIsAtDelvry(value);
        break;
      case "CONSDLAY":
        setIsConsDlay(value);
        break;
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEnter = () => {
    setFilter(values.join().toUpperCase());
    handleClose();
  };

  const handleClear = () => {
    handleDeselectAll();
    setFilter(undefined);
    handleClose();
  };

  const handleSelectAll = () => {
    setIsPrevious(true);
    setIsPreplan(true);
    setIsDrvrdna(true);
    setIsDispatch(true);
    setIsDly2Ship(true);
    setIsAtShipr(true);
    setIsShipDlay(true);
    setIsMoving(true);
    setIsDotBreak(true);
    setIsItDelay(true);
    setIsAtDelvry(true);
    setIsConsDlay(true);
    setValues(allStatus);
  };

  const handleDeselectAll = () => {
    setIsPrevious(false);
    setIsPreplan(false);
    setIsDrvrdna(false);
    setIsDispatch(false);
    setIsDly2Ship(false);
    setIsAtShipr(false);
    setIsShipDlay(false);
    setIsMoving(false);
    setIsDotBreak(false);
    setIsItDelay(false);
    setIsAtDelvry(false);
    setIsConsDlay(false);
    setValues([]);
  };

  useEffect(() => {
    if (!filterValue) {
      handleClear();
    }
  }, [filterValue]);

  return (
    <>
      <FilterButton
        filterValue={filterValue}
        onClick={handleOpen}
      />
      <StyledPopover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        titleObject={
          <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
            <Typography variant="subhead1">Sort by {Header}</Typography>
          </span>}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-evenly", color: "primary.60", textDecoration: "underline", cursor: "pointer" }}>
          <Typography onClick={handleSelectAll}>Select All</Typography>
          <Typography onClick={handleDeselectAll}>Deselect All</Typography>
        </Box>
        <Box sx={{
          margin: "20px 0 25px 0",
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)"
        }}>
          <FormGroup sx={{ marginTop: "20px", height: "270px", width: "200px" }}>
            {statuses.map((status) => (
              <FormControlLabel
                key={`checkbox-${status.id}`}
                control={
                  <Box sx={{ margin: "8px" }}>
                    <PrimaryCheckbox
                      checked={status.value}
                      handleChange={handleSelected}
                      value={status.id}
                      color="black_solid.60"
                    />
                  </Box>
                }
                label={
                  <CallinStatusPill value={status.id} />
                }
              />
            ))}
          </FormGroup>
        </Box>
        <Box sx={{ display: "flex" }}>
          {filterValue &&
            <SecondaryButton
              label="Clear"
              onClick={handleClear}
            />
          }
          <Box sx={{ margin: "0 20px 0 auto" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleClose}
            />
          </Box>
          <PrimaryButton
            label="Go"
            onClick={handleEnter}
            width="50px"
          />
        </Box>
      </StyledPopover>
    </>
  );
}

CallinStatusFilter.propTypes = {
  column: PropTypes.object.isRequired
};
